export default "/images/SL_habitacle.png?c1c65e8c47a8ce1836e0bfe8bbdb23e1";